var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings-engineers-audit-log" } }, [
    _c("div", { staticClass: "clearfix" }, [
      _c("div", { staticClass: "float-left audit-log-header" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("settings.auditLogExport.title")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm.hasPermission()
        ? _c("div", { staticClass: "float-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button", disabled: !_vm.startDate },
                on: {
                  click: function ($event) {
                    return _vm.exportData()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.export")))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
    ]),
    _vm._v(" "),
    _vm.hasPermission()
      ? _c(
          "div",
          { staticClass: "row clearfix" },
          [
            _c("DatePicker", {
              attrs: {
                id: "audit-log-start-date",
                format: "DD MMM YY",
                calendarButton: true,
                placeholder: _vm.$t("settings.auditLogExport.startFrom"),
                disabled: _vm.startDisabledDatesUntil,
                calendarButtonIcon: "fa fa-calendar",
              },
              model: {
                value: _vm.startDate,
                callback: function ($$v) {
                  _vm.startDate = $$v
                },
                expression: "startDate",
              },
            }),
            _vm._v(" "),
            _c("DatePicker", {
              attrs: {
                id: "audit-log-end-date",
                format: "DD MMM YY",
                calendarButton: true,
                placeholder: _vm.$t("settings.auditLogExport.until"),
                disabled: _vm.endDisabledDatesUntil,
                calendarButtonIcon: "fa fa-calendar",
              },
              model: {
                value: _vm.endDate,
                callback: function ($$v) {
                  _vm.endDate = $$v
                },
                expression: "endDate",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }